// @ts-nocheck
import * as React from "react";

const QuestionMarkCircleLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="m12 2 .28.004C17.673 2.152 22 6.57 22 12l-.004.28C21.848 17.673 17.43 22 12 22 6.477 22 2 17.523 2 12S6.477 2 12 2Zm0 2a8 8 0 1 0 0 16l.25-.004A8 8 0 0 0 20 12l-.004-.25A8 8 0 0 0 12 4Zm.707 12.293a1 1 0 1 1-1.414 1.414 1 1 0 0 1 1.414-1.414ZM12 6l.194.004A3.49 3.49 0 0 1 13 12.84V14a1 1 0 1 1-2 0v-2l.007-.117A1 1 0 0 1 12 11l.144-.007A1.5 1.5 0 1 0 10.5 9.5l-.007.117A1 1 0 0 1 8.5 9.5l.005-.192A3.5 3.5 0 0 1 12 6Z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(QuestionMarkCircleLine);
